import { setMe, setUnreadInboxCount } from "@/core/redux/slices/user";
import { useDispatch, useSelector } from "@/core/redux/store";
import authService from "@/shared/services/api/auth-service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function SpecificationLayoutViewModel() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const specification = useSelector(
    (state) => state.specification.specification
  );
  const dispatch = useDispatch();

  const getUserData = async () => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (refreshToken === "norefresh") return;
    const userResponse = await authService.getMe();
    if (userResponse.success) {
      const userDetail = userResponse.data.user;
      dispatch(setMe(userDetail));
      dispatch(setUnreadInboxCount(userResponse.data.unreadInboxCount));
    }
  };

  useEffect(() => {
    getUserData();
  }, []);
  return {
    t,
    specification,
    navigate,
  };
}
